import {useRequestHelper} from "@/helpers/request.helper";
import type {LoginColaboradorCommand} from "@/domain/commands/auth.commands";
import type {VerificarUsuarioSessaoCommand} from "@/domain/commands/usuario.commands";
import type {UsuarioColaboradorLoginVm} from "@/domain/type/auth.type";
import type {UsuarioColaboradorVm} from "@/domain/type/usuario.type";



const requestHelper = useRequestHelper();



class AuthService {

    login(userCommand: LoginColaboradorCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorLoginVm>('usuario/colaborador/login', userCommand, false);
    }

    verificarSessao(command: VerificarUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorLoginVm>('usuario/colaborador/sessao/verificar', command, false);
    }

    verificarUsuarioAutenticado() {
        return requestHelper.sendRequestGet<UsuarioColaboradorVm>('usuario/colaborador/info');
    }



}

export default new AuthService();